import HNSColors from "../../../ui library/HNSColors";

export default function AnalyticsHeaderSection({ title, description }) {
  const now = new Date();
  const formattedDate = now.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col justify-between gap-4 md:flex-row md:items-start">
        <div className="mb-2">
          <h1 className="text-2xl font-semibold" style={{ color: HNSColors.primary[500] }}>
            {title}
          </h1>
          <p className="mt-1 max-w-2xl text-sm" style={{ color: HNSColors.neutrals[400] }}>
            {description}
          </p>
        </div>
        <div className="text-xs md:text-right" style={{ color: HNSColors.neutrals[100] }}>
          <div className="font-medium">Last updated</div>
          <div>{formattedDate}</div>
        </div>
      </div>
    </div>
  );
}
